
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {ReporteServices} from '../services/reporte.services';
import {Component, OnInit} from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import {ComisionServices} from '../../ComisionesModule/services/comision.services';
import * as moment from 'moment';
import {forkJoin} from 'rxjs';

import {EmpleadoReporteModel} from '../models/empleado.reporte.model';
import {SemanaServices} from '../../FriedmanModule/services/semana.services';
import {SemanaReporteModel} from '../models/semana.reporte.model';

@Component({
  selector:"reporte-estado",
  templateUrl:"../templates/reporte.estado.template.html"
})
export class ReporteEstadoComponent implements OnInit{
  public fechaIni:string = "";
  public fechaFin:string = "";

  public tiendas:TiendaEntity[] = [];

  public tiendaSelect:TiendaEntity;

  public lstEmpleadoReportes:EmpleadoReporteModel[] = [];

  public tiendaReporte:SemanaReporteModel = new SemanaReporteModel();
  public consultando = 0;
  public dataGraphEmple:any[] = [];

  constructor(private ts:TiendaServices, private rs:ReporteServices, private spinner:NgxSpinnerService, private cs:ComisionServices, private ss:SemanaServices){

  }

  ngOnInit(): void {
    this.spinner.show();
    this.ts.getAllTiendas().subscribe((d:any)=>{
      this.tiendas = d.data.tiendas;
      this.spinner.hide();
    })
  }


  consultarReporte(){

    this.consultando = 1;
    let fecha1 = moment(this.fechaIni);
    let fecha2 = moment(this.fechaFin);
    let listaIds:any[] = [];
    this.lstEmpleadoReportes = [];
    this.dataGraphEmple = [];
    this.spinner.show();
    this.rs.getListEmpleadosCalendarioXTienda(fecha1.format("DD-MM-YYYY"), fecha2.format("DD-MM-YYYY"), this.tiendaSelect.idDB).subscribe((d)=>{

      listaIds = d.data.listaIdEmpledosCalendarioxTienda;

      this.ss.devolverSemanaCalendarioTienda(fecha1.format("DD-MM-YYYY"), fecha2.format("DD-MM-YYYY"), this.tiendaSelect.idDB).subscribe((d2:any)=>{

        this.tiendaReporte = new SemanaReporteModel();
        this.tiendaReporte.idTienda = this.tiendaSelect.idDB;
        this.tiendaReporte.nombre = this.tiendaSelect.nombre;
        for(let sem of d2.data.semanaFechaCalTienda){
          this.tiendaReporte.addSemanaReporte(sem);
        }


        console.log(this.tiendaReporte);

        let consultas: any[] = [];

        for (let e of listaIds) {
          consultas.push(this.cs.getInfoEmpleadoCalendario(e, fecha1.format("DD-MM-YYYY"), fecha2.format("DD-MM-YYYY")));
        }

        forkJoin(consultas).subscribe((d3: any) => {



          for (let ec of d3) {
            let data = ec.data.infoMetaEmpleadoCalendario;

            if (data) {
              let empleCom = new EmpleadoReporteModel();
              empleCom.crearEmpleadoReporte(data);
              this.tiendaReporte.agregarVentas(data.ventas);
              empleCom.calcularIndicadores(fecha1, fecha2);
              this.dataGraphEmple.push(empleCom.dataGraficas);
              this.lstEmpleadoReportes.push(empleCom);
            }
          }
          this.tiendaReporte.calcularIndicadores(fecha1, fecha2);

          this.spinner.hide();
          this.consultando = 2;

        });

      })



    })



  }


}
